import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'wrapWith',
    standalone: false
})
export class WrapWithPipe implements PipeTransform
{
    transform (value: any, args = ['(', ')']): any
    {
        if (args && args.length > 1)
        {
            return `${args[0]}${value}${args[1]}`;
        }

        return value;
    }
}